export const rollingTodayPeriods = ['today', 'sinceToday', 'tomorrow'] as const;
export const rolling7DaysPeriods = ['last7Days', 'next7Days'] as const;
export const rolling30DaysPeriods = ['last30Days', 'next30Days'] as const;

export const completeWeekPeriods = ['lastWeek', 'thisWeek', 'nextWeek'] as const;
export const completeMonthPeriods = ['lastMonth', 'thisMonth', 'nextMonth'] as const;

export const predefinedPeriods = [
  ...rollingTodayPeriods,
  ...rolling7DaysPeriods,
  ...rolling30DaysPeriods,
  ...completeWeekPeriods,
  ...completeMonthPeriods,
] as const;
